import { ApiError } from '@thyme/libs/src/api/apiRequest'
import { IdMap } from './api/store'

// TYPES --------------------
export type Notification = {
  message: string | ApiError | Error | null
  description?: string
  type: NotificationType
  error?: string | Error | undefined

  isPersistent?: boolean
  uniqueId?: string
}

export type NotificationState = {
  notification: Notification | null
  persistentNotification: Notification | null

  notifications: IdMap<Notification>
  persistentNotifications: IdMap<Notification>
}

// ENUMS --------------------
export enum NotificationType {
  DANGER = 'danger',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export enum NotificationActions {
  CREATE = 'creating',
  UPDATE = 'updating',
  DELETE = 'deleting',
  FETCH = 'fetching',
}

export const notificationActionToPastTense = {
  [NotificationActions.CREATE]: 'created',
  [NotificationActions.UPDATE]: 'updated',
  [NotificationActions.DELETE]: 'deleted',
  [NotificationActions.FETCH]: 'fetched',
}

// CONSTANTS --------------------
export const notificationClasses = [
  'flex',
  'justify-between',
  'items-start',
  'gap-2',
]

export const notificationTypeToIcon = {
  [NotificationType.DANGER]: 'heroicons:x-circle',
  [NotificationType.INFO]: 'heroicons:information-circle',
  [NotificationType.SUCCESS]: 'heroicons:check-20-solid',
  [NotificationType.WARNING]: 'heroicons:exclamation-triangle',
  '': '',
}

export const notificationTypeToColor = {
  [NotificationType.DANGER]: 'bg-nash-brick600',
  [NotificationType.INFO]: 'bg-nash-midnightBlue700',
  [NotificationType.SUCCESS]: 'bg-nash-fern600',
  [NotificationType.WARNING]: 'bg-nash-tigerlily800',
  '': '',
}
